import type { SVGProps } from 'react';
export const Share = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="m12.2 14.5-4.95-2.93-.24.2q-.51.36-1.18.37a2.1 2.1 0 0 1-2.08-2.11c0-1.17.93-2.11 2.08-2.11a2 2 0 0 1 1.42.57l4.9-2.89a3 3 0 0 1-.07-.5c0-1.16.93-2.1 2.09-2.1a2.1 2.1 0 0 1 2.08 2.1 2.1 2.1 0 0 1-2.08 2.12 2 2 0 0 1-1.42-.57l-4.9 2.89a3 3 0 0 1 .07.49l-.01.18-.06.31 4.96 2.92.23-.2q.48-.33 1.13-.34c1.11 0 2.02.92 2.02 2.05S15.3 17 14.17 17a2.04 2.04 0 0 1-1.98-2.5m1.5.15-.05.18-.01.12c0 .32.25.55.53.55.27 0 .52-.23.52-.55a.54.54 0 0 0-.52-.55.5.5 0 0 0-.35.14zM6.36 9.71l-.14-.13a.6.6 0 0 0-.39-.16.6.6 0 0 0-.58.6c0 .36.28.62.58.62q.2 0 .4-.17l.13-.12.03-.14.03-.18-.03-.18zm7.28-4.28.14.12q.18.18.39.17a.6.6 0 0 0 .58-.61.6.6 0 0 0-.58-.61.6.6 0 0 0-.56.79z"
      clipRule="evenodd"
    />
  </svg>
);
